/**
 * Was a rejected request cancelled rather than failed?
 *
 * Screens that refetch on every scope/filter change abort the request they are
 * replacing. Axios rejects the aborted promise, and that rejection must not be
 * reported as an error or allowed to clear the screen — the replacement request
 * is already on its way.
 */
export function isRequestCanceled(err: any): boolean {
  if (!err) return false;
  return (
    err.code === 'ERR_CANCELED' ||
    err.name === 'CanceledError' ||
    err.name === 'AbortError' ||
    err.__CANCEL__ === true
  );
}
